import React, {Component, PropTypes} from "react"
import moment from "moment"
import {connectReduxForm} from "redux-form";
import {connect} from "react-redux";
import Spinner from '@jimpick/react-spinner';
import {intercom, firebase} from "../../../appConfig"
import {resetEditUserForm, editUser} from "actions/paywallActions";
import Regionalization from "services/regionalization";

function validateEditUser(data) {
  const errors = {};
  if (!data.email) {
    errors.email = 'required';
  }
  if (!data.cityOrMunicipality) {
    errors.cityOrMunicipality = 'required';
  }
  if (!data.stateOrProvince) {
    errors.stateOrProvince = 'required';
  }
  if (!data.country) {
    errors.country = 'required';
  }
  return errors
}

@connect(
  (state) => ({ error: state.paywall.error }),
  { resetEditUserForm, editUser }
)
@connectReduxForm({
  form: 'editUser',
  fields: ['email', 'cityOrMunicipality', 'stateOrProvince', 'country', 'tester'],
  validate: validateEditUser
})
export default class UserPanel extends Component {

  static propTypes = {
    error: PropTypes.string.isRequired,
    profile: PropTypes.object,
    fields: PropTypes.object.isRequired,
    userId: PropTypes.string.isRequired,
    deleteUser: PropTypes.func,
    clearFound: PropTypes.func,
    toggleTester: PropTypes.func,
    resetEditUserForm: PropTypes.func.isRequired,
    editUser: PropTypes.func.isRequired
  };

  static contextTypes = {
    userId: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      editing: false,
      saving: false
    }
    this.countries = Regionalization.getCountries();
  }

  componentWillReceiveProps(nextProps) {
    if ((nextProps.fields.stateOrProvince.value === this.props.fields.stateOrProvince.value)
        && (nextProps.fields.country.value !== this.props.fields.country.value)
    ) {
      const defaultValue = Regionalization.hasStatesOrProvinces(nextProps.fields.country.value) ? '' : 'Other';
      this.props.fields.stateOrProvince.onChange(defaultValue);
    }
  }

  render() {
    const {
      error,
      profile,
      userId,
      fields: {
        email,
        cityOrMunicipality,
        stateOrProvince,
        country,
        tester
      },
      values
    } = this.props;
    const {
      editing,
      saving
    } = this.state;

    if (!profile) {
      return <div/>;  // Can happen while loading
    }

    const statesOrProvinces = Regionalization.getStatesOrProvinces(country.value);
    if (statesOrProvinces.length === 1) {
      stateOrProvince.disabled = true;
    }

    const intercomBase = `https://app.intercom.com/apps/${intercom}`;
    const intercomLink = `${intercomBase}/users/show?user_id=${userId}`;
    const firebaseBase = `https://${firebase}.firebaseio.com`;
    const firebaseLink = `${firebaseBase}/users/${userId}`;
    const staffUserLink = `/staff/user/${userId}`;
    const isSearchResult = !!this.props.deleteUser;

    if (!profile.school) {
      return <div/>
    }

    return <div className="well form-horizontal paywallUserForm">
      <div className="row">
      <div className="col-sm-6">
        <div className="form-group">
          <label className="col-xs-2 col-sm-4 control-label">
            Email
          </label>
          <div className="col-xs-10 col-sm-8">
            {editing
              ? <div>
                  <input id="txtEmail"
                         type="email"
                         className="form-control"
                         placeholder="jane@example.com"
                         spellCheck="false"
                         disabled={saving}
                         value={values.email}
                         {...email} />
                  {email.error && email.touched &&
                    <div className="text-danger" dangerouslySetInnerHTML={{__html: email.error}}></div>
                  }
                </div>
              : <a href={intercomLink} target="_blank">{profile.email}</a>
            }
          </div>
        </div>
        <div className="form-group">
          <label className="col-xs-2 col-sm-4 control-label">
            First Name
          </label>
          <div className="col-xs-10 col-sm-8">
            {profile.firstName}
          </div>
        </div>
        <div className="form-group">
          <label className="col-xs-2 col-sm-4 control-label">
            Last Name
          </label>
          <div className="col-xs-10 col-sm-8">
            {profile.lastName}
          </div>
        </div>
        <div className="form-group">
          <label className="col-xs-2 col-sm-4 control-label">
            School
          </label>
          <div className="col-xs-10 col-sm-8">
            {profile.school}
          </div>
        </div>
        <div className="form-group">
          <div className="col-xs-12 error">
            {error}
          </div>
        </div>
        <div className="form-group">
          <div className="col-xs-12">
            {isSearchResult && !editing &&
            <button
                className="btn btn-primary btn-sm"
                onClick={::this._editUser}>
              Edit user
            </button>
            }
            {isSearchResult && editing &&
                <button
                    className="btn btn-primary btn-sm"
                    disabled={email.error || cityOrMunicipality.error || stateOrProvince.error || country.error}
                    onClick={::this._saveUser}>
                  Save user {saving && <Spinner />}
                </button>
            }
            &nbsp;
            {isSearchResult &&
            <button
              className="btn btn-primary btn-sm"
              onClick={() => this.props.deleteUser({userId, staffUserId: this.context.userId})}>
              Delete user
            </button>
            }
            &nbsp;
            {isSearchResult &&
            <button
              className="btn btn-sm"
              onClick={() => this.props.clearFound()}>
              Back to search
            </button>
            }
          </div>
        </div>
      </div>
      <div className="col-sm-6">
        <div className="form-group">
          <label className="col-xs-2 col-sm-4 control-label">
            City
          </label>
          <div className="col-xs-10 col-sm-8">
            {editing
              ? <div>
                <input id="txtCity"
                       className="form-control"
                       placeholder="Vancouver"
                       spellCheck="false"
                       disabled={saving}
                       value={values.cityOrMunicipality}
                       {...cityOrMunicipality} />
                {cityOrMunicipality.error && cityOrMunicipality.touched &&
                  <div className="text-danger" dangerouslySetInnerHTML={{__html: cityOrMunicipality.error}}></div>
                }
              </div>
              : profile.cityOrMunicipality
            }
          </div>
        </div>
        <div className="form-group">
          <label className="col-xs-2 col-sm-4 control-label">
            State or Province
          </label>
          <div className="col-xs-10 col-sm-8">
            {editing
              ? <div>
                <select id="selectState"
                        className="form-control"
                        disabled={saving}
                        value={values.stateOrProvince}
                        {...stateOrProvince}>
                  <option value=""> - Select State or Province -</option>
                  {statesOrProvinces.map(item => <option key={item.code} value={item.code}>{item.name}</option>)}
                </select>
                {stateOrProvince.error && stateOrProvince.touched &&
                  <div className="text-danger" dangerouslySetInnerHTML={{__html: stateOrProvince.error}}></div>
                }
              </div>
              : profile.stateOrProvince
            }
          </div>
        </div>
        <div className="form-group">
          <label className="col-xs-2 col-sm-4 control-label">
            Country
          </label>
          <div className="col-xs-10 col-sm-8">
            {editing
              ? <div>
                <select id="selectState"
                        className="form-control"
                        disabled={saving}
                        value={values.country}
                        {...country}>
                  <option value=""> - Select Country -</option>
                  <option value="Canada">Canada</option>
                  <option value="United States">United States</option>
                  <option disabled> ────────── </option>
                  {this.countries.map(item => <option key={item} value={item}>{item}</option>)}
                </select>
                {country.error && country.touched &&
                  <div className="text-danger" dangerouslySetInnerHTML={{__html: country.error}}></div>
                }
              </div>
              : profile.country
            }
          </div>
        </div>
        <div className="form-group">
          <label className="col-xs-2 col-sm-4 control-label">
            Signup Date
          </label>
          <div className="col-xs-10 col-sm-8">
            {profile.createdAt && moment(profile.createdAt).local().toString()}
          </div>
        </div>
        <div className="form-group">
          <label className="col-xs-2 col-sm-4 control-label">
            User ID
          </label>
          <div className="col-xs-10 col-sm-8">
            {isSearchResult
              ? <a href={firebaseLink} target="_blank">{userId}</a>
              : <a href={staffUserLink}>{userId}</a>
            }
          </div>
        </div>
        <div className="form-group">
          <label className="col-xs-2 col-sm-4 control-label">
            Beta Tester
          </label>
          <div className="col-xs-10 col-sm-8">
            {editing
              ? <input type="checkbox"
                       {...tester}
                       disabled={saving}
                       checked={!!values.tester} />
              : <input type="checkbox" disabled checked={profile.tester} />
            }
          </div>
        </div>
      </div>
      </div>
      <div className="row">
        <div className="col-xs-12">
          {this.props.children}
        </div>
      </div>
    </div>
  }

  _editUser() {
    const { email, cityOrMunicipality, stateOrProvince, country, tester = false } = this.props.profile;
    this.props.resetEditUserForm({
      email, cityOrMunicipality, stateOrProvince, country, tester
    });
    this.setState({
      editing: true
    });
  }

  _saveUser() {
    const {userId: staffUserId} = this.context;
    const {userId, values} = this.props;
    this.setState({ saving: true });
    this.props.editUser(userId, values, { staffUserId })
      .catch(error => {
        console.error('Failed to save user.', error)
        this.setState({ error: 'Oops something went wrong. Please try again.' });
      })
      .then(() => this.setState({ editing: false, saving: false }));
  }
}



// WEBPACK FOOTER //
// ./src/views/staff/userPanel.jsx